import React, { Component } from 'react';
import TempImage1 from '../../assets/images/temp/1.jpg';
import ProjectHeader from '../ProjectHeader';

class ProjectFish extends Component {
	render() {
		return (
			<div className="publish-container__wrapper">
				<ProjectHeader />
				<h1 className="title-h1 bold">Fish ou of the bowl</h1>
				<span className="title-caption step-4">Comics</span>
				<div className="publish-container">
					<p>
						<span className="drop_cap">L</span>orem ipsum dolor sit amet, consectetur adipiscing elit. In a
						elementum metus. Nunc non dapibus felis. <a href="">Praesent id enim</a> tempor, sollicitudin
						metus nec, rhoncus nisl. Pellentesque placerat sagittis quam sit amet luctus. Sed velit libero,
						bibendum eget porttitor ut, pharetra at tellus. Aenean sapien ex, pellentesque vitae magna vel,
						viverra tincidunt justo. Cras sed quam magna. Nam id lacus eu dui sollicitudin volutpat.
					</p>
					<a className="link--image" data-fancybox data-caption="Caption for single image" href={TempImage1}>
						<img src={TempImage1} alt="Caption for single" />
					</a>
					<h3>Morbi sit amet congue</h3>
					<p>
						Aenean congue, neque eu sodales imperdiet, sapien est commodo ante, porta auctor mauris diam nec
						ex. Nulla urna diam, consequat in auctor id, congue quis justo. Fusce feugiat semper commodo.
						Morbi sit amet congue sem. Proin dictum nisl at elit hendrerit, non porta tortor pulvinar. Etiam
						efficitur augue quis leo sagittis, eu ornare arcu rutrum. Aliquam ullamcorper pellentesque
						nulla, luctus mattis urna sollicitudin vitae. Cras fermentum nulla aliquet arcu blandit posuere.
						Integer convallis erat ut tortor lacinia dignissim. Proin metus arcu, fermentum vel velit vitae,
						tempus pharetra augue. In euismod interdum volutpat. Nullam vitae varius risus. Morbi non
						sollicitudin libero.
					</p>
				</div>
			</div>
		);
	}
}

export default ProjectFish;
